import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import PortfolioSection from './PortfolioSection';
import TextSection from './TextSection';

class Home extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>Home - Hubton Indonesia</title>
                </Helmet>

                <PortfolioSection />
                <TextSection />
            </div>
        )
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/index.js